import { getAuth, onAuthStateChanged } from 'firebase/auth';

const authReady = () => {
  return new Promise((resolve) => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      resolve(user);
    });
  });
};

export default authReady;
